import React from "react";
import { getVar, SubTitle, Text } from './Helper';
import styled from 'styled-components';

const baseUrl = getVar().baseUrl;
    const PinImage = styled.img`
        position: relative;
        top: 50%;       
        transform: translateY(-50%);
        padding-top:20px;
        padding-bottom:20px;
        max-width: 100%;
        &:hover {
            opacity:0.6;
            cursor:pointer; 
        }
        @media (max-width: ${getVar().med}) {
            top: 25px; 
            transform: translateY(0%);
        }
        @media (max-width: ${getVar().sm}) {
            margin-bottom: 30px;
        }
    `;
    const PinWrap = styled.div`
        margin-bottom :15px; 
        padding:0px 25px 0 0;
        background-color: #fff; 
        margin-left: 0;
        @media (max-width: ${getVar().med}) {
            margin-left: 0px;
        }    
        @media (max-width: ${getVar().sm}) {
            text-align:center;
        }    
    `;
    const TextWrap = styled.div`
        padding-left:30px;
        border-left:1px solid #ebebeb;
        padding-top:15px;
        padding-bottom:15px;
    `;

    const Btn = styled.a`
        margin-top:10px;
        margin-bottom:10px;
        margin-right:7px;
        font-size:12px;
    ` 


function PinDetails({pin, showMiniModal}){    
      
    return (
        <PinWrap className="row container">
            {(()=>{
                if(pin.imageSrc){
                    return (
                        <div className="col-lg-3 col-sm-6" style={{position:'relative', textAlign:'center'}}>
                            <PinImage onClick={()=>{showMiniModal(pin.imageSrc)}}  src={baseUrl + pin.imageSrc} alt={pin.name} />
                        </div>
                    )
                }                   
            })()}         
            <TextWrap className={`${pin.imageSrc ? "col-lg-9 col-sm-6" : "col-lg-12 col-sm-12"}`}>
                <SubTitle>{pin.name}</SubTitle>
                <Text>{pin.description}</Text>
                {(()=>{
                    if(pin.url){
                        return <Btn href={pin.url} className="btn btn-sm btn-success">Learn More</Btn>
                    }                   
                })()}
                {(()=>{
                    if(pin.videoUrl){
                        return <Btn onClick={()=>{showMiniModal(pin.videoUrl)}} className="btn btn-sm btn-success">Watch Video</Btn>
                    }                   
                })()}
            </TextWrap>  
        </PinWrap>
    );
}

export default PinDetails;